import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { Record, Map as ImmutableMap } from 'immutable';
import { TINYMCE } from '../constants/edit/ArticleConstants';
import { getLegacyArticlePayload } from '../utils/articleVisibilityUtils';
const MissingValue = 'MISSING_VALUE';
export const oldKeys = ['absoluteUrl', 'author', 'authorName', 'archived', 'articleBody', 'articleSummary', 'created', 'customSlugEnding', 'generator', 'hasTranslatedContent', 'id', 'knowledgeBaseCategory', 'knowledgeBaseSubcategory', 'knowledgeCategoryId', 'language', 'lastLoaded', 'publicAccessRules', 'publicAccessRulesEnabled', 'contentGroupId', 'name', 'position', 'previewKey', 'publishedAt', 'state', 'tagIds', 'title', 'translatedContent', 'translatedContentLanguages', 'translatedFromId', 'updated', 'headHtml', 'htmlTitle', 'metaDescription', 'masterId', 'publishedById', 'createdById', 'updatedById', 'knowledgeCategoryId'];
const convertOldArticleToNewArticle = oldArticleJson => {
  const convertedTranslations = oldArticleJson.translatedContent ? Object.keys(oldArticleJson.translatedContent).reduce((acc, key) => {
    acc[key] = convertOldArticleToNewArticle(oldArticleJson.translatedContent[key]);
    return acc;
  }, {}) : {};
  return {
    isConvertedFromLegacy: true,
    authorName_temp: oldArticleJson.authorName || '',
    values: {
      hs_analytics_page_id: oldArticleJson.id || 0,
      hs_group_id: oldArticleJson.contentGroupId || 0,
      hs_generator_temp: oldArticleJson.generator || TINYMCE,
      hs_body: oldArticleJson.articleBody || '',
      hs_knowledge_sub_category: oldArticleJson.knowledgeBaseSubcategory,
      hs_knowledge_category: oldArticleJson.knowledgeBaseCategory,
      hs_knowledge_category_id: oldArticleJson.knowledgeCategoryId,
      hs_summary: oldArticleJson.articleSummary || '',
      hs_archived_in_dashboard: oldArticleJson.archived ? 1 : 0,
      hs_position: oldArticleJson.position || 0,
      hs_preview_key: oldArticleJson.previewKey || '',
      hs_tag_ids: oldArticleJson.tagIds || [],
      hs_head_html: oldArticleJson.headHtml || '',
      hs_meta_description: oldArticleJson.metaDescription || '',
      hs_slug: oldArticleJson.customSlugEnding || '',
      hs_domain: '',
      hs_name: oldArticleJson.name,
      hs_legitimate_interest_lawful_basis: '',
      hs_language: oldArticleJson.language,
      hs_gdpr_consent_type: '',
      hs_access_rule_ids: oldArticleJson.publicAccessRules && oldArticleJson.publicAccessRules[0] ? oldArticleJson.publicAccessRules[0].ids : [],
      hs_access_rule_type: oldArticleJson.publicAccessRules && oldArticleJson.publicAccessRules[0] ? oldArticleJson.publicAccessRules[0].type : PublicAccessRuleTypes.PUBLIC,
      hs_absolute_url: oldArticleJson.absoluteUrl || '',
      hs_id: oldArticleJson.id || 0,
      hs_created_at: oldArticleJson.created,
      hs_updated_at: oldArticleJson.updated || 0,
      hs_published_at: oldArticleJson.publishedAt || 0,
      hs_state: oldArticleJson.state,
      hs_created_by_user_id: oldArticleJson.createdById || 0,
      hs_updated_by_user_id: oldArticleJson.updatedById || 0,
      hs_published_by_user_id: oldArticleJson.publishedById || 0,
      hs_translated_from_id: oldArticleJson.translatedFromId
    },
    translations: convertedTranslations
  };
};
const ValuesRecord = Record({
  hs_analytics_page_id: 0,
  hs_generator_temp: TINYMCE,
  hs_body: '',
  hs_knowledge_category: undefined,
  hs_knowledge_sub_category: undefined,
  hs_knowledge_category_id: 0,
  hs_summary: '',
  hs_archived_in_dashboard: 0,
  hs_position: 0,
  hs_preview_key: '',
  hs_tag_ids: [],
  hs_head_html: '',
  hs_meta_description: '',
  hs_slug: '',
  hs_domain: '',
  hs_name: '',
  hs_legitimate_interest_lawful_basis: '',
  hs_language: '',
  hs_gdpr_consent_type: '',
  hs_access_rule_ids: [],
  hs_access_rule_type: PublicAccessRuleTypes.PUBLIC,
  hs_absolute_url: '',
  hs_id: 0,
  hs_created_at: 0,
  hs_updated_at: 0,
  hs_published_at: 0,
  hs_state: '',
  hs_created_by_user_id: 0,
  hs_updated_by_user_id: 0,
  hs_published_by_user_id: 0,
  hs_group_id: 0,
  hs_translated_from_id: undefined
});
const getValuesPropertyOrReturnMissingResult = (article, key) => {
  return article.values && Object.hasOwn(article.values, key) ? article.values[key] : MissingValue;
};
class Article extends Record({
  isConvertedFromLegacy: false,
  authorName_temp: '',
  values: ValuesRecord(),
  translations: {}
}) {
  constructor(json = {}) {
    if (json &&
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    !json.values) {
      const oldJson = json;
      json = convertOldArticleToNewArticle(oldJson);
    }
    const data = json;
    super(Object.assign({}, data, {
      values: ValuesRecord(data.values)
    }));
  }
  updateVisibility(payload) {
    if (!payload.values) {
      const legacyPayload = payload;
      return this.setIn(['values', 'hs_access_rule_ids'], legacyPayload.publicAccessRules && legacyPayload.publicAccessRules[0] ? legacyPayload.publicAccessRules[0].ids : []).setIn(['values', 'hs_access_rule_type'], legacyPayload.publicAccessRules && legacyPayload.publicAccessRules[0] ? legacyPayload.publicAccessRules[0].type : PublicAccessRuleTypes.PUBLIC);
    }
    return this.setIn(['values', 'hs_access_rule_ids'], payload.values.hs_access_rule_ids).setIn(['values', 'hs_access_rule_type'], payload.values.hs_access_rule_type);
  }
}
Article.toOldFormat = article => {
  return ImmutableMap({
    absoluteUrl: getValuesPropertyOrReturnMissingResult(article, 'hs_absolute_url'),
    archived: getValuesPropertyOrReturnMissingResult(article, 'hs_archived_in_dashboard'),
    articleBody: getValuesPropertyOrReturnMissingResult(article, 'hs_body'),
    articleSummary: getValuesPropertyOrReturnMissingResult(article, 'hs_summary'),
    customSlugEnding: getValuesPropertyOrReturnMissingResult(article, 'hs_slug'),
    id: getValuesPropertyOrReturnMissingResult(article, 'hs_id'),
    knowledgeBaseCategory: getValuesPropertyOrReturnMissingResult(article, 'hs_knowledge_category'),
    knowledgeBaseSubcategory: getValuesPropertyOrReturnMissingResult(article, 'hs_knowledge_sub_category'),
    knowledgeCategoryId: getValuesPropertyOrReturnMissingResult(article, 'hs_knowledge_category_id'),
    language: getValuesPropertyOrReturnMissingResult(article, 'hs_language'),
    publicAccessRules: article.values && article.values.hs_access_rule_type ? getLegacyArticlePayload({
      hs_access_rule_ids: article.values.hs_access_rule_ids || [],
      hs_access_rule_type: article.values.hs_access_rule_type
    }).publicAccessRules : MissingValue,
    publicAccessRulesEnabled: article.values && article.values.hs_access_rule_type ? getLegacyArticlePayload({
      hs_access_rule_ids: article.values.hs_access_rule_ids || [],
      hs_access_rule_type: article.values.hs_access_rule_type
    }).publicAccessRulesEnabled : MissingValue,
    contentGroupId: getValuesPropertyOrReturnMissingResult(article, 'hs_group_id'),
    name: getValuesPropertyOrReturnMissingResult(article, 'hs_name'),
    position: getValuesPropertyOrReturnMissingResult(article, 'hs_position'),
    previewKey: getValuesPropertyOrReturnMissingResult(article, 'hs_preview_key'),
    state: getValuesPropertyOrReturnMissingResult(article, 'hs_state'),
    tagIds: getValuesPropertyOrReturnMissingResult(article, 'hs_tag_ids'),
    title: getValuesPropertyOrReturnMissingResult(article, 'hs_name'),
    translatedContent: article.translations ? Object.keys(article.translations).reduce((acc, key) => {
      acc[key] = Article.toOldFormat((article.translations || {})[key]);
      return acc;
    }, {}) : MissingValue,
    translatedContentLanguages: article.translations ? Object.keys(article.translations) : MissingValue,
    translatedFromId: getValuesPropertyOrReturnMissingResult(article, 'hs_translated_from_id'),
    headHtml: getValuesPropertyOrReturnMissingResult(article, 'hs_head_html'),
    htmlTitle: getValuesPropertyOrReturnMissingResult(article, 'hs_name'),
    metaDescription: getValuesPropertyOrReturnMissingResult(article, 'hs_meta_description'),
    masterId: article.values && Object.hasOwn(article.values, 'values') ? article.values.hs_translated_from_id : MissingValue
  }).filter(value => value !== MissingValue).toJS();
};
export default Article;